import { singletonCallback } from './singleton-hooks';

// lob site goto
type GotoFn = (
  s: string,
  mode?: 'PUSH' | 'REPLACE',
  isCheckCookie?: boolean,
) => void;

interface PostMsgParams {
  action?: string;
  targetUrl?: string;
  params?: { [key: string]: string };
}

// hk-emma-web main site goto
type MainSiteGotoFn = (
  appDeepLink: string,
  currentTitle?: string,
  params?: PostMsgParams,
  isReplace?: boolean,
) => void;

const goto: GotoFn | MainSiteGotoFn = () => {
  console.warn('Please setGoto before using useGoto');
};

const payload = singletonCallback<GotoFn | MainSiteGotoFn>(goto, 'useGoto');

/**
 * Bridge shared state between application and modules
 * @category Setters
 * @example
setGoto((string) => router.push(string));
**/
export const setGoto = payload.setGlobalCallback;

/**
 * Access goto function from any modules with hooks
 * @category Hooks
 * @example
const uri = '/whatever';
const goto = useGoto();
useEffect(() => { goto(uri) }, []);
**/
export const useGoto = payload.useGlobalCallback;
